import { useParams } from "react-router-dom";
import { DealerUserInfoProvider } from "src/context/DealerUserInfoContext";
import { AddEmployeeModalProvider } from "src/context";
import { DgaModalProvider } from "src/context/DgaModalContext";
import ProtectedLayout from "./ProtectedLayout";

export default () => {
  const { dealer_id } = useParams();
  return (
    <DealerUserInfoProvider dealerId={dealer_id}>
      <AddEmployeeModalProvider>
        <DgaModalProvider>
          <ProtectedLayout />
        </DgaModalProvider>
      </AddEmployeeModalProvider>
    </DealerUserInfoProvider>
  );
};
